import { render, staticRenderFns } from "./ReviewsAnalystRatingsChart.vue?vue&type=template&id=eac133c0&scoped=true&"
import script from "./ReviewsAnalystRatingsChart.vue?vue&type=script&lang=js&"
export * from "./ReviewsAnalystRatingsChart.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsAnalystRatingsChart.vue?vue&type=style&index=0&id=eac133c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eac133c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
